export const KliHintersType = Object.freeze({
    general: 'general',
    success: 'success',
    error: 'error',
    alert: 'alert'
});
